import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
Vue.prototype.$axios = Axios; //在Vue的原型上添加$axios方法
import i18n from '@/lang/index' //国际化

import FastClick from 'fastclick'
// import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/scss/global.scss';
import './plugins/element.js'
import './plugins/udesk.js'
import './plugins/backend'
// 引入 （main.js)


// 使用（main.js)

// FastClick.attach(document.body);
import VueCookie from 'vue-cookie'
Vue.use(VueCookie)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')